import { render, staticRenderFns } from "./NotificationPopover.vue?vue&type=template&id=b0afaf8c&scoped=true"
import script from "./NotificationPopover.vue?vue&type=script&lang=js"
export * from "./NotificationPopover.vue?vue&type=script&lang=js"
import style0 from "./NotificationPopover.vue?vue&type=style&index=0&id=b0afaf8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0afaf8c",
  null
  
)

export default component.exports